module.exports = __webpack_public_path__ + "img/7m.3a17473c.jpg";